import React, { useContext } from "react"

// The context for use by the Providers and hook
const EFSDataContext = React.createContext()

// The Provider component for the EFS Input
// This grabs all of the data attributes of the tag with the given ID
// This data is parsed and then provided into a context which can be
// consumed by the following hooks
export function EFSInputProvider({
  parseJSON = true,
  efsDataID = "efs-data",
  setEFSDataCallback = "setEFSDataCallback",
  children
}) {
  // imports the EFS input data tag
  const efsDataTag = document.getElementById(efsDataID)
  let efsData = {}

  if (efsDataTag) {
    efsData = { ...efsDataTag.dataset }

    if (parseJSON) {
      Object.keys(efsData).forEach(key => {
        try {
          const parsedData = JSON.parse(efsData[key])
          efsData[key] = parsedData
        } catch (err) {
          // Ignore the error - not great!
        }
      })
    }
  }

  // Parse the global function if it exists
  if (window[setEFSDataCallback]) {
    efsData = { ...efsData, ...window[setEFSDataCallback]() }
  }

  return (
    <EFSDataContext.Provider value={efsData}>
      {children}
    </EFSDataContext.Provider>
  )
}

// A custom hook to get the EFS data from the context
// This ensures that any components that need this data doesn't
// need to know about this context or how it works
// This also allows us to change the internal method in the future
export function useEFSData() {
  const data = useContext(EFSDataContext)
  return data
}

// A component which tabulates all of the inputs provided by the EFS Input
// and provided in the context. This is designed purely for debugging
// This has a single prop - debug - which can be set to false to deactivate
// this component
export function EFSInputDebug({ debug = true }) {
  const efsData = useEFSData()

  // Return the table is debug is set to true, otherwise render nothing
  return debug ? (
    <table>
      <thead>
        <tr>
          <th>Var Name</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(efsData).map(key => (
          <tr key={`row-${key}`}>
            <td>{key}</td>
            <td>{efsData[key]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : null
}
